import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";

import styles from "./Modal.module.css";

//Basic modal with a blue background. Modal action bar can be used with modal to add btns.
export function Modal({ isOpen, className, children }) {
  return (
    <>
      <ReactModal
        isOpen={isOpen}
        className={styles.modal}
        overlayClassName={styles.overlay}
      >
        <div className={className}>{children}</div>
      </ReactModal>
    </>
  );
}

Modal.propTypes = {
  //Boolean to determine if modal is open
  isOpen: PropTypes.bool,
  //Passed in to make changes to the modals style
  className: PropTypes.string,
};
